import 'toastify-js/src/toastify.css';
import Toastify from 'toastify-js';

const form = document.querySelector('#contacts-form');

form.addEventListener('submit', e => submitForm(e));

async function submitForm(event) {
  event.preventDefault();

  clearErrors();

  const name = document.getElementById('nameInput');
  const phone = document.getElementById('phoneInput');
  const from = document.getElementById('fromInput');
  const to = document.getElementById('toInput');

  const phonePattern = /^\+?[0-9\s\-\(\)]{10,18}$/;

  if (name.value.trim().length < 2 || name.value.trim().length > 50) {
    showError(name);
    return;
  }

  if (!phonePattern.test(phone.value.trim())) {
    showError(phone);
    return;
  }

  const formData = {
    name: event.target.elements.name.value,
    phone: event.target.elements.tel.value,
    from: event.target.elements.from.value,
    to: event.target.elements.to.value,
  };

  fetch('tel.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({
      text: generateMessCall(formData),
    }),
  }).then(response => {
    if (response.ok) {
      window.gtag('event', 'contact_form_submission', {
        contact_form: 'submission',
      });

      successNotification();
      form.reset();
    } else {
      errorNotification();
    }
  });
}

function generateMessCall(formData) {
  return `Нове замовлення! \n\nІм’я: ${formData.name} \nНомер телефону: ${formData.phone} \nЗвідки: ${formData.from} \nКуди: ${formData.to}.`;
}

function successNotification() {
  Toastify({
    text: 'Контакти успішно відправлені!',
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'top',
    position: 'center',
    stopOnFocus: true,
    style: {
      background: 'linear-gradient(to right, #00b09b, #96c93d)',
    },
  }).showToast();
}

function errorNotification() {
  Toastify({
    text: 'Помилка відправки!',
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'top',
    position: 'center',
    stopOnFocus: true,
    style: {
      background: 'linear-gradient(to right, #ff5f6d, #ffc371)',
    },
  }).showToast();
}

function showError(input) {
  input.classList.add('input-error');
}

function clearErrors() {
  document
    .querySelectorAll('.input-error')
    .forEach(el => el.classList.remove('input-error'));
}
